import type { LocalCartItem, Ticket } from 'restful/tickets';
import { TicketStatusFragment } from 'types/api/dato-operations.types';

import TicketItemAccordion from 'components/@events/EventDetailCartContainer/TicketItemAccordion';
import AmountSelector from 'components/@tickets/AmountSelector';

interface Props {
  ticket: Ticket;
  status?: TicketStatusFragment;
  cartItem: LocalCartItem | undefined;
  onAddItem: (ticket: Ticket) => void;
  onRemoveItem: (ticket: Ticket) => void;
}

const TicketItem = ({
  ticket,
  status,
  cartItem,
  onAddItem,
  onRemoveItem,
}: Props) => {
  const quantity = cartItem?.quantity ?? 0;

  const handleAdd = () => onAddItem(ticket);
  const handleRemove = () => onRemoveItem(ticket);

  return (
    <TicketItemAccordion ticket={ticket} status={status}>
      <AmountSelector
        quantity={quantity}
        isRemoveDisabled={quantity <= 0}
        onRemove={handleRemove}
        onAdd={handleAdd}
      />
    </TicketItemAccordion>
  );
};

export default TicketItem;
